import {
    getClaimPayments,
    appealClaimPayment,
    payInFullClaim,
    payInFullClaimBill,
    editClaimPaymentInfo,
    getRemittance,
    createRemittance,
    verifyRemittance,
    markReviewedRemittance,
    syncTlClearinghouseEras,
    getRemittanceById,
    editRemittance,
    voidRemittance,
    massVoidRemittance,
    getRemittanceTotal,
    removeClaimFromRemittance,
    getRemittanceByIdClaims,
    getClaimPaymentFiltered,
    deleteRemittance,
} from './claimPayment.action.js';
export { claimPaymentReducer } from './claimPayment.reducer';
export { watchClaimPayment } from './claimPayment.saga';

export const claimPaymentActions = {
    /** Claim Payment */
    createRemittance,
    editRemittance,
    getRemittance,
    verifyRemittance,
    markReviewedRemittance,
    syncTlClearinghouseEras,
    getRemittanceById,
    getRemittanceByIdClaims,
    voidRemittance,
    massVoidRemittance,
    deleteRemittance,
    getRemittanceTotal,

    getClaimPaymentFiltered,
    getClaimPayments,
    editClaimPaymentInfo,
    appealClaimPayment,
    payInFullClaim,
    payInFullClaimBill,
    removeClaimFromRemittance,
    /** End */
};
